import { SvgIcon } from "@mui/material";
import { IStyleProps } from "@/models";
import { memo } from "react";

const CheckedFillIcon = ({ sx, ...otherProps }: IStyleProps) => {
  return (
    <SvgIcon
      viewBox="0 0 17 18"
      sx={{
        fontSize: "inherit",
        fill: "none",
        ...sx,
      }}
      {...otherProps}
    >
      <g clipPath="url(#clip0_4933_13611)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.36182 0.788574C3.74317 0.788574 -0.000976562 4.53272 -0.000976562 9.15137C-0.000976562 13.77 3.74317 17.5142 8.36182 17.5142C12.9805 17.5142 16.7246 13.77 16.7246 9.15137C16.7246 4.53272 12.9805 0.788574 8.36182 0.788574ZM6.3025 12.5941C6.42794 12.7195 6.58127 12.7753 6.74853 12.7753C6.91578 12.7753 7.06909 12.7195 7.20847 12.5941L13.2158 6.60074C13.4666 6.34986 13.4666 5.95959 13.2158 5.70871C12.9649 5.45783 12.5746 5.45783 12.3237 5.70871L6.76246 11.256L4.42087 8.92839C4.16999 8.67751 3.77974 8.67751 3.52886 8.92839C3.27797 9.17927 3.27797 9.56953 3.52886 9.82042L6.3025 12.5941Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_4933_13611">
          <rect
            width="16.7256"
            height="16.7256"
            fill="white"
            transform="translate(-0.000976562 0.788574)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
export default memo(CheckedFillIcon);
